import { tWithKeyAttr as t } from "../i18nHelper";
export const setCookie = (
  name: string,
  value: string | number | boolean,
  props?: { [key: string]: any; expires?: number | Date | string; path?: string }
) => {
  props = props || {};

  // Handle expires
  if (typeof props.expires === "number") {
    const d = new Date();
    d.setTime(d.getTime() + props.expires * 1000); 
    props.expires = d;
  }
  if (props.expires instanceof Date) {
    props.expires = props.expires.toUTCString();
  }
  const encodedValue = encodeURIComponent(value);
  let updatedCookie = `${name}=${encodedValue}`;

  // Add path (default to '/')
  updatedCookie += `; path=${props.path ?? "/"}`;

  for (const propName in props) {
    if (propName === "path" || propName === "expires") continue; 
    const propValue = props[propName];
    updatedCookie += "; " + propName;
    if (propValue !== true) {
      updatedCookie += "=" + propValue;
    }
  }

  // Add expires at the end
  if (props.expires) {
    updatedCookie += `; expires=${props.expires}`;
  }
  document.cookie = updatedCookie;
};

export const getCookie = (name: string): string | undefined => {
  const matches = document.cookie.match(
    // eslint-disable-next-line
    new RegExp(
      "(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export function deleteCookie(name: string) {
  const expires = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
  const pathList = ["/", window.location.pathname];

  pathList.forEach((path) => {
    document.cookie = `${name}=; ${expires}; path=${path}`;
  });
}
